module.exports = __webpack_public_path__ + "img/thumb-008-07.74c81c19.png";